module.exports = __webpack_public_path__ + "static/media/mobile.958663aa.png";